import React from "react";
import {NavItem, Outer, Workspace, WorkspaceNotch} from "../shopdrawing/ShopNav";
import {useProject} from "../shopdrawing/ProjectName";
import {useAlternative} from "./alternative/Alternative";
import {PricingPopup} from "./PricingPopup";
import {HourglassBottom} from "@mui/icons-material";
import {yellow} from "@mui/material/colors";

export const QuoteNav = function ShopNav() {
    const proj = useProject();
    const alt = useAlternative();

    return <Outer>
        <Workspace>
            Workspace
            <WorkspaceNotch />
        </Workspace>
        <NavItem name="Openings" quote locked={proj?.quoteLockedOpenings === alt} isIndex />
        <NavItem name="Hardware" quote locked={proj?.quoteLockedHardware === alt} />
        <NavItem name="Glazing" quote />
        <NavItem name="Div 10" quote locked={(()=> {
            if(!proj) return false;
            if(proj.quoteLockedDiv10WrAccessories === alt) return true
            if(proj.quoteLockedDiv10WrPartitions === alt) return true
            if(proj.quoteLockedDiv10Lockers === alt) return true
            if(proj.quoteLockedDiv10Mailboxes === alt) return true
            if(proj.quoteLockedDiv10CornerGuards === alt) return true
            return false;
        })()} />
        <NavItem name="Misc" quote />
        <NavItem
            name="Pricing"
            quote
            extraIcon={proj?.quotePausePricing && <div style={{color: yellow["600"], height: "1em"}}><HourglassBottom fontSize="inherit" color="inherit" /></div>}
            onPopup={(ctrl) => {
                return <PricingPopup onClose={ctrl.close} />
            }}
        />
    </Outer>
};